import { _, dictionary, locale, getLocaleFromNavigator } from "svelte-i18n";
import { get } from "svelte/store";
import it from "./it.json";
import en from "./en.json";

let initialized = false;

const init = () => {
    if (!initialized) {
        dictionary.set({
            it: it,
            en: en
        });
        locale.set(getLocaleFromNavigator());
    }
};

export const t = (key, options = {}) => {
    init();
    return get(_)(key, options);
};
